module.exports = __webpack_public_path__ + "img/C2.33c0dab9.png";